"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRequestError = exports.getRequestErrorType = void 0;
const axios_1 = __importDefault(require("axios"));
function getRequestErrorType(error) {
    if (axios_1.default.isCancel(error))
        return 'canceled';
    else if (error === null || error === void 0 ? void 0 : error.response)
        return 'status-above-2xx';
    return 'no-response';
}
exports.getRequestErrorType = getRequestErrorType;
/**
 * Caso o retorno seja `true`, garante que o tipo do argumento recebido é `HttpClientRequestError`.
 *
 * @public
 * @example
 * try {
 *   const response = await httpClient.get('/something')
 *   return response.data
 * } catch(error) {
 *   const errorType = isRequestError(error) ? error.type : 'erro não identificado'
 *   setRequestError(errorType)
 * }
 */
function isRequestError(error) {
    return (typeof error === 'object' && error !== null && '__isHttpClientRequestError' in error);
}
exports.isRequestError = isRequestError;
//# sourceMappingURL=http-client-utils.js.map